import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { DEFAULT_LANGUAGE } from '../../config/languages';

/**
 * RootRedirect Component
 * 
 * Redirects root path and any non-language-prefixed routes
 * to the default language version, preserving path and query params
 */
const RootRedirect = () => {
    const location = useLocation();

    // If path is just '/', redirect to default language root
    if (location.pathname === '/') {
        return <Navigate to={`/${DEFAULT_LANGUAGE}`} replace />;
    }

    // Otherwise prepend language to current path
    const newPath = `/${DEFAULT_LANGUAGE}${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
};

export default RootRedirect;
